import React from 'react'
import PropTypes from 'prop-types'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {GoogleMap, Marker, useJsApiLoader} from '@react-google-maps/api'

import {getUrl} from '../../../../utils/cloudinary-utils'

const Map = ({store}) => {
    const {
        app: {commerceAPI}
    } = getConfig()
    const {apiKey} = commerceAPI.googleMaps

    const containerStyle = {
        width: '100%',
        height: '100%'
    }

    const center = {
        lat: store?.latitude || 0,
        lng: store?.longitude || 0
    }

    const {isLoaded} = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: apiKey
    })

    const onLoad = React.useCallback(function callback(map) {
        const bounds = new window.google.maps.LatLngBounds(center)
        map.fitBounds(bounds)
    }, [])

    return (
        isLoaded && (
            <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={10} onLoad={onLoad}>
                <Marker
                    position={center}
                    icon={{
                        url: getUrl('UIImages/images/kslogo_marker.png'),
                        scaledSize: new window.google.maps.Size(47, 73)
                    }}
                />
            </GoogleMap>
        )
    )
}

Map.propTypes = {
    store: PropTypes.shape({
        ID: PropTypes.string,
        name: PropTypes.string,
        distance: PropTypes.string,
        calloutMessage: PropTypes.string,
        latitude: PropTypes.number,
        longitude: PropTypes.number,
        phone: PropTypes.string,
        address1: PropTypes.string,
        city: PropTypes.string,
        stateCode: PropTypes.string,
        zip: PropTypes.string
    })
}

export default Map
